(function () {
  'use strict';

  const BASE_URL = 'https://comnexus-snj-api.btpro.net';
  const PRODUCT_GID = 'gid://shopify/Product/';
  const VARIANT_GID = 'gid://shopify/ProductVariant/';
  const ARTICLE_GID = 'gid://shopify/Article/';
  const TOAST_DURATION = 5000;
  let token;
  let favorites = [];
  let articleFavorites = [];
  let articlesEnabled = false;
  let favoriteIds = new Set();
  let articleIds = new Set();
  let currentCustomer;
  let toast;
  let toastTimer;
  let loginModal;
  let lastFocus;

  function getCustomer() {
    const footer = document.querySelector('footer[data-customer-id]');
    if (!footer) return null;

    const email = footer.dataset.customerEmail;
    const customerId = footer.dataset.customerId;
    return email && customerId ? { email, customerId } : null;
  }

  async function request(path, options) {
    const response = await fetch(`${BASE_URL}${path}`, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  async function getToken(customer) {
    const result = await request('/api/v1/customer/get-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store, no-transform' },
      body: JSON.stringify(customer)
    });
    return result.data.token;
  }

  function authHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Cache-Control': 'no-store, no-transform'
    };
  }

  async function getFavorites() {
    const result = await request('/api/v1/customer-favorites', { method: 'GET', headers: authHeaders() });
    return Array.isArray(result.data) ? result.data : [];
  }

  // Tarif ucu henuz yayinda olmayabilir: hata durumunda ozellik kapali kalir,
  // uc yayina alindigi anda kendiliginden acilir.
  async function getArticleFavorites() {
    try {
      const result = await request('/api/v1/customer-favorites/articles', { method: 'GET', headers: authHeaders() });
      articlesEnabled = true;
      return Array.isArray(result.data) ? result.data : [];
    } catch (error) {
      articlesEnabled = false;
      return [];
    }
  }

  function cacheKey() {
    return `wishlist:ids:${currentCustomer && currentCustomer.customerId}`;
  }

  function readCache() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(cacheKey()));
      return parsed && Array.isArray(parsed.products) && Array.isArray(parsed.articles) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(total) {
    try {
      sessionStorage.setItem(cacheKey(), JSON.stringify({
        products: Array.from(favoriteIds),
        articles: Array.from(articleIds),
        count: total
      }));
    } catch (error) {
      // Kota dolu ya da gizli sekme: onbellek olmadan da calisir
    }
  }

  function cleanId(value, prefix) {
    return String(value || '').replace(prefix, '');
  }

  function isFavorite(productId) {
    return favoriteIds.has(String(productId));
  }

  function isArticleFavorite(articleId) {
    return articleIds.has(String(articleId));
  }

  function updateButtons() {
    document.querySelectorAll('button[data-wishlist-toggle][data-product-id]').forEach((button) => {
      const active = isFavorite(button.dataset.productId);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
      button.title = active ? 'Favorilerden çıkar' : 'Favorilere ekle';
    });

    document.querySelectorAll('button[data-wishlist-article-toggle][data-article-id]').forEach((button) => {
      const active = isArticleFavorite(button.dataset.articleId);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
      button.title = active ? 'Favorilerden çıkar' : 'Favorilere ekle';
    });
  }

  function syncIds() {
    favoriteIds = new Set(favorites.map((product) => cleanId(product.shopifyProductId, PRODUCT_GID)));
    articleIds = new Set(articleFavorites.map((article) => cleanId(article.shopifyArticleId, ARTICLE_GID)));
  }

  function setCounters(total) {
    document.querySelectorAll('.icon--wishlist__quantity').forEach((counter) => {
      counter.textContent = total;
      counter.setAttribute('aria-label', `${total} favori`);
    });
  }

  // Ag beklemeden onbellekten boyar; gercek veri gelince uzerine yazilir.
  function paintFromCache() {
    const cache = readCache();
    if (!cache) return;

    favoriteIds = new Set(cache.products.map(String));
    articleIds = new Set(cache.articles.map(String));
    updateButtons();
    setCounters(cache.count || 0);
  }

  function updateInterface() {
    syncIds();
    updateButtons();

    const validCount = favorites.filter((product) => (
      product.price !== null &&
      product.handle &&
      product.title &&
      Array.isArray(product.images) &&
      product.images.length > 0
    )).length;

    const total = validCount + articleFavorites.length;

    setCounters(total);
    writeCache(total);

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { favorites, articles: articleFavorites, articlesEnabled }
    }));
  }

  function getToast() {
    if (toast === undefined) {
      toast = document.querySelector('[data-wishlist-toast]');
      if (toast) {
        toast.addEventListener('mouseenter', () => window.clearTimeout(toastTimer));
        toast.addEventListener('mouseleave', () => {
          toastTimer = window.setTimeout(hideToast, TOAST_DURATION);
        });
      }
    }
    return toast;
  }

  function hideToast() {
    const element = getToast();
    if (!element) return;

    window.clearTimeout(toastTimer);
    element.classList.remove('wishlist-toast--visible');
  }

  function onFavoritesPage(element) {
    const url = element.dataset.favoritesUrl;
    if (!url) return false;
    return window.location.pathname.replace(/\/$/, '') === url.replace(/\/$/, '');
  }

  function showToast(options) {
    const element = getToast();
    if (!element) return;

    const image = element.querySelector('[data-wishlist-toast-image]');
    const title = element.querySelector('[data-wishlist-toast-title]');
    const subtitle = element.querySelector('[data-wishlist-toast-subtitle]');
    const action = element.querySelector('[data-wishlist-toast-action]');

    element.classList.remove('wishlist-toast--added', 'wishlist-toast--removed', 'wishlist-toast--error');
    element.classList.add(`wishlist-toast--${options.state}`);

    title.textContent = options.title;
    subtitle.textContent = options.subtitle || '';
    subtitle.hidden = !options.subtitle;

    if (options.image) {
      image.src = options.image;
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
    }

    action.hidden = !options.action || onFavoritesPage(element);

    element.classList.add('wishlist-toast--visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, TOAST_DURATION);
  }

  function getLoginModal() {
    if (loginModal === undefined) loginModal = document.querySelector('[data-wishlist-modal]');
    return loginModal;
  }

  function openLoginModal(trigger) {
    const modal = getLoginModal();
    if (!modal) return false;

    lastFocus = trigger;
    modal.hidden = false;
    document.body.classList.add('wishlist-modal-open');

    const focusTarget = modal.querySelector('[data-wishlist-modal-focus]');
    if (focusTarget) focusTarget.focus();
    return true;
  }

  function closeLoginModal() {
    const modal = getLoginModal();
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('wishlist-modal-open');
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }

  function productInfo(button) {
    const favorite = favorites.find((product) => (
      cleanId(product.shopifyProductId, PRODUCT_GID) === String(button.dataset.productId)
    ));
    const card = button.closest('.product-card, .wishlist-card, .product-title-container');
    const cardTitle = card && card.querySelector('.product-card-title, .wishlist-card__title, .product-title');
    const cardImage = card && card.querySelector('img');

    return {
      title: button.dataset.productTitle
        || (favorite && favorite.title)
        || (cardTitle && cardTitle.textContent.trim())
        || '',
      image: button.dataset.productImage
        || (favorite && Array.isArray(favorite.images) && favorite.images[0])
        || (cardImage && (cardImage.currentSrc || cardImage.src))
        || ''
    };
  }

  function productPayload(button, removing) {
    const existing = removing && favorites.find((product) => (
      cleanId(product.shopifyProductId, PRODUCT_GID) === String(button.dataset.productId)
    ));
    const productId = existing ? cleanId(existing.shopifyProductId, PRODUCT_GID) : button.dataset.productId;
    const variantId = existing ? cleanId(existing.shopifyProductVariantId, VARIANT_GID) : button.dataset.variantId;

    return {
      favoriteProducts: [{
        shopifyProductId: PRODUCT_GID + productId,
        shopifyProductVariantId: VARIANT_GID + variantId,
        priceWhenFavorited: Math.round(Number.parseFloat(button.dataset.price) || 0)
      }]
    };
  }

  async function toggleFavorite(button) {
    if (button.disabled || !token) return;

    const removing = button.classList.contains('active');
    const product = productInfo(button);
    button.disabled = true;
    try {
      await request(removing ? '/api/v1/customer-favorites/remove' : '/api/v1/customer-favorites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Cache-Control': 'no-store, no-transform'
        },
        body: JSON.stringify(productPayload(button, removing))
      });
      favorites = await getFavorites();
      updateInterface();
      showToast({
        state: removing ? 'removed' : 'added',
        title: removing ? 'Favorilerinden çıkarıldı' : 'Favorilerine eklendi',
        subtitle: product.title,
        image: product.image,
        action: removing === false
      });
    } catch (error) {
      console.error(removing ? 'Favorilerden çıkarma işlemi başarısız:' : 'Favoriye ekleme işlemi başarısız:', error);
      showToast({
        state: 'error',
        title: removing ? 'Favorilerden çıkarılamadı' : 'Favorilere eklenemedi',
        subtitle: 'Lütfen birazdan tekrar dene.',
        action: false
      });
    } finally {
      button.disabled = false;
    }
  }

  function articlePayload(button, removing) {
    const item = { shopifyArticleId: ARTICLE_GID + button.dataset.articleId };

    if (!removing) {
      item.handle = button.dataset.articleHandle;
      item.blogHandle = button.dataset.blogHandle;
    }

    return { favoriteArticles: [item] };
  }

  async function toggleArticleFavorite(button) {
    if (button.disabled || !token) return;

    const removing = button.classList.contains('active');
    button.disabled = true;
    try {
      await request(removing ? '/api/v1/customer-favorites/articles/remove' : '/api/v1/customer-favorites/articles', {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(articlePayload(button, removing))
      });
      articleFavorites = await getArticleFavorites();
      updateInterface();
      showToast({
        state: removing ? 'removed' : 'added',
        title: removing ? 'Favorilerinden çıkarıldı' : 'Favorilerine eklendi',
        subtitle: button.dataset.articleTitle,
        image: button.dataset.articleImage,
        action: removing === false
      });
    } catch (error) {
      console.error(removing ? 'Tarifi favorilerden çıkarma başarısız:' : 'Tarifi favoriye ekleme başarısız:', error);
      showToast({
        state: 'error',
        title: removing ? 'Favorilerden çıkarılamadı' : 'Favorilere eklenemedi',
        subtitle: 'Lütfen birazdan tekrar dene.',
        action: false
      });
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-wishlist-toast-close]')) {
      hideToast();
      return;
    }

    if (event.target.closest('[data-wishlist-modal-close]')) {
      closeLoginModal();
      return;
    }

    const loginLink = event.target.closest('a[data-wishlist-login]');
    if (loginLink) {
      if (openLoginModal(loginLink)) event.preventDefault();
      return;
    }

    const articleButton = event.target.closest('button[data-wishlist-article-toggle][data-article-id]');
    if (articleButton) {
      toggleArticleFavorite(articleButton);
      return;
    }

    const button = event.target.closest('button[data-wishlist-toggle][data-product-id]');
    if (button) toggleFavorite(button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeLoginModal();
    hideToast();
  });

  document.addEventListener('product:variant-change', (event) => {
    if (!event.detail || !event.detail.variant) return;
    document.querySelectorAll('.product-wishlist--product').forEach((button) => {
      button.dataset.variantId = event.detail.variant.id;
      button.dataset.price = event.detail.variant.price / 100;
    });
  });

  document.addEventListener('DOMContentLoaded', async () => {
    const customer = getCustomer();
    if (!customer) return;

    currentCustomer = customer;
    paintFromCache();

    try {
      token = await getToken(customer);
      [favorites, articleFavorites] = await Promise.all([getFavorites(), getArticleFavorites()]);
      // Teshis kancasi: tarif ucunun yayinda olup olmadigi buradan gorulur
      document.body.classList.toggle('wishlist-recipes-ready', articlesEnabled);
      updateInterface();

      const observer = new MutationObserver((mutations) => {
        const hasWishlistContent = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches('[data-wishlist-toggle], [data-wishlist-article-toggle]') ||
            node.querySelector('[data-wishlist-toggle], [data-wishlist-article-toggle]'))
        )));
        if (hasWishlistContent) updateButtons();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      console.error('Favori ürünler yüklenemedi:', error);
      document.dispatchEvent(new CustomEvent('wishlist:error'));
    }
  });
}());
